import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  CircularProgress,
  createStyles,
  makeStyles,
  Typography,
} from "@material-ui/core";
import classNames from "classnames";
import React, { useCallback, useEffect, useRef } from "react";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { useLocation } from "react-router-dom";
import ErrorDialog from "../common/ErrorDialog";
import { fetchRunbook } from "../../helper/Api";
import { errors, getApiError } from "../../helper/Error";
import { useStateSafe } from "../../helper/customHook";

// CSSスタイルを定義
const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      margin: theme.spacing(2),
    },
    koumoku: {
      whiteSpace: "pre-line",
    },
    text: {
      fontSize: 20,
      background:
        "linear-gradient(90deg, rgba(237, 119, 128, 0) 0%, rgba(237, 119, 128, 0) 50%, #fff 0%, #fff 100%), linear-gradient(180deg, rgba(100, 100, 100, 0) 0%, rgba(100, 100, 100, 0) 97.5%, #646464 100%)",
      backgroundSize: "8px 100%,100% 2em",
      lineHeight: "2em",
      marginBottom: theme.spacing(6),
      whiteSpace: "pre-line",
      "&:last-child": {
        marginBottom: theme.spacing(3),
      },
    },
    loader: {
      display: "flex",
      justifyContent: "center",
      marginTop: theme.spacing(22),
    },
    nothing: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      whiteSpace: "pre-line",
      fontSize: 22,
      marginTop: theme.spacing(22),
    },
    accordion: {
      width: "100%",
      maxWidth: "600px",
    },
    detail: {
      flexDirection: "column",
    },
  })
);

export default function Manual() {
  const classes = useStyles();

  const [isLoading, setIsLoading] = useStateSafe(true);
  const location = useLocation();
  const { serviceId } = location.state;
  const [data, setData] = useStateSafe([]);

  const errorRef = useRef({});
  const [isOpenError, setIsOpenError] = useStateSafe(false);
  const handleCloseError = useCallback(() => {
    setIsOpenError(false);
  }, [setIsOpenError]);

  useEffect(() => {
    const fn = async () => {
      await fetchRunbook(serviceId)
        .then((res) => {
          if (res.data.error.length === 0) setData(res.data.result);
          else throw res.data.error;
        })
        .catch((err) => {
          errorRef.current = err.code
            ? getApiError(err)
            : errors.APP_CONNECTION_FAILED;
          setIsOpenError(true);
        });
      setIsLoading(false);
    };
    fn();
  }, [serviceId, setData, setIsOpenError, setIsLoading]);

  return (
    <>
      {isLoading ? (
        <div className={classes.loader}>
          <CircularProgress />
        </div>
      ) : data.length === 0 || data.tejunsho === null ? (
        <Typography color="textSecondary" className={classes.nothing}>
          {"手順書はありません"}
        </Typography>
      ) : (
        <div className={classes.root}>
          {data.tejunsho.meisai.map((item, index) => (
            <Accordion
              key={index}
              defaultExpanded={index ? false : true}
              className={classes.accordion}
            >
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography className={classes.koumoku}>
                  {item.koumoku}
                </Typography>
              </AccordionSummary>

              <AccordionDetails className={classes.detail}>
                <Typography variant="subtitle1" color="primary">
                  サービスの内容と手順
                </Typography>
                <Typography className={classNames(classes.text, "canSelect")}>
                  {item.naiyou}
                </Typography>

                <Typography variant="subtitle1" color="primary">
                  留意事項
                </Typography>

                <Typography className={classNames(classes.text, "canSelect")}>
                  {item.ryuui}
                </Typography>
              </AccordionDetails>
            </Accordion>
          ))}

          {data.tejunsho.note && (
            <Accordion className={classes.accordion}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography>注意事項</Typography>
              </AccordionSummary>

              <AccordionDetails className={classes.detail}>
                <Typography className={classNames(classes.text, "canSelect")}>
                  {data.tejunsho.note}
                </Typography>
              </AccordionDetails>
            </Accordion>
          )}
        </div>
      )}

      <ErrorDialog
        open={isOpenError}
        onClose={handleCloseError}
        error={errorRef.current}
      />
    </>
  );
}
